import React from 'react';

type ConsultPartnerCodeBadgeProps = {
  code: string;
  /** Slightly smaller for dense queue cards. */
  size?: 'sm' | 'md';
};

/** Partner / promo code used at patient-portal Stripe checkout (e.g. SGAIR, 57MGE). */
export function ConsultPartnerCodeBadge({ code, size = 'md' }: ConsultPartnerCodeBadgeProps) {
  const trimmed = code.trim().toUpperCase();
  if (!trimmed) return null;

  const fontSize = size === 'sm' ? 10 : 11;
  const padding = size === 'sm' ? '2px 8px' : '3px 10px';

  return (
    <span
      title={`Paid with partner / promo code: ${trimmed}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding,
        borderRadius: 12,
        fontSize,
        fontWeight: 700,
        lineHeight: 1.2,
        background: '#fef3c7',
        color: '#92400e',
        border: '1px solid #fcd34d',
        whiteSpace: 'nowrap',
        letterSpacing: '0.02em',
      }}
    >
      <span aria-hidden style={{ flexShrink: 0 }}>
        🏷
      </span>
      <span>{trimmed}</span>
    </span>
  );
}
